'use client'

import { ThemeProvider } from '@/components/site/theme-provider'

/** Marketing site only - no Firebase auth. */
export function SiteProviders({ children }: { children: React.ReactNode }) {
  return (
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem disableTransitionOnChange>
      {children}
    </ThemeProvider>
  )
}
